<template>
    <div class="bot-form-rt wid">
        <el-dialog
                custom-class="dellDiaLogClass"
                :append-to-body="true"
                @close="dialogVisible = false"
                :visible.sync="dialogVisible"
                width="30%">
            <template>
                <!-- 市价交易 -->
                <span>确认撤销委托</span>
            </template>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleClose()">确 定</el-button>
            </span>
        </el-dialog>
        <div class="form-rt-head">
            <div class="form-shua" v-if="cancel_msg !== '已撤单'" @click="cancelorder()">选中撤单</div>
            <div class="form-shua disabled" v-else>选中已撤单</div>
        </div>
        <div class="form-rt-body">
            <div class="form-rt-subhead wid" :style="{'min-width': getMiniWidth() + 'px'}">
                <div class="subhead-nav"
                     :class="{'w': tag.length === 3}"
                     v-for="tag in headers"
                     :key="tag[1]">{{tag[0]}}
                </div>
            </div>
            <div class="form-rt-neir wid" v-for="data in datas"
                 :style="{'min-width': getMiniWidth() + 'px'}"
                 :class="{'active': activeIds === data.id}"
                 :key="data.id">
                <div class="neir-nav"
                     :class="{'w': tag.length === 3}"
                     @click="setThisActive(data.id, data.cancel_type, data.msg)"
                     v-for="tag in headers"
                     :key="tag[1]">
                    <template v-if="tag[1] === 'cancel_ctrl'">
                        <template v-if="data.msg ==='已撤单' || data.msg ==='撤单中'">{{data.msg}}</template>
                        <button v-else @click="cancelorder()">撤单</button>
                    </template>
                    <template v-else>
                        {{$globle.itemValue(data[tag[1]], tag[1])}}
                    </template>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "BaseFooterCancelTheOrder",
        data() {
            return {
                headers: Object.freeze(this.$globle.chedanstrategyTag),
                datas: [],
                activeIds: null,
                cancel_msg: null,
                cancel_type: null,
                intrvalHand: null,
                dialogVisible: false
            }
        },
        created() {
            this.chedanstrategy();
        },
        beforeDestroy() {
            if (this.intrvalHand) {
                clearInterval(this.intrvalHand)
            }
        },
        computed: {
            token: function () {
                return this.$store.state.now_token;
            },
            trade_account: function () {
                return this.$store.state.now_trade_account;
            },
            isopen() {
                return this.$store.state.isopen;
            }
        },
        watch: {
            isopen(v) {
                if (v) {
                    this.chedanstrategy();
                }
            }
        },
        methods: {
            chedanstrategy() {
                if (this.intrvalHand) {
                    clearInterval(this.intrvalHand)
                }
                this.$api.canchedan(this.token, this.trade_account).then(res => {
                    if (res.data.code === 200) {
                        this.datas = Object.freeze(res.data.data);
                    } else {
                        this.datas = []
                    }
                    if (this.isopen) {
                        this.intrvalHand = setTimeout(() => {
                            this.chedanstrategy();
                        }, this.$globle.cancelOrderTime);
                    }
                })
            },
            setThisActive(id, cancel_type, msg) {
                this.activeIds = id;
                this.cancel_msg = msg;
                this.cancel_type = cancel_type;
            },
            cancelorder() {
                if (!this.dialogVisible) {
                    this.dialogVisible = true;
                } else {
                    this.$api.cancelorder(this.token, this.trade_account, this.cancel_type, this.activeIds).then(res => {
                        if (res.data.code === 200) {
                            this.$message({
                                message: res.data.data,
                                type: 'success'
                            });
                            this.$store.commit('UPDATE_ACCOUNT_INFO');
                            this.$store.commit('UPDATE_RIGHT_INFO');
                            this.chedanstrategy();
                        } else {
                            this.$message.error(res.data.msg);
                        }
                        this.dialogVisible = false;
                        this.cancel_type = null;
                        this.cancel_msg = null;
                        this.activeIds = null;
                    })
                }
            },
            // 自动计算表格的宽度
            getMiniWidth() {
                let wCount = 0;
                this.headers.map(v => {
                    if (v.length === 3) {
                        wCount++;
                    }
                });
                return 119 * this.headers.length + 82 * wCount
            },
            handleClose() {
                this.cancelorder();
            }
        }
    }
</script>

<style scoped>
    .form-rt-neir,
    .form-rt-subhead {
        min-width: 1244px;
    }

    .form-rt-neir.active {
        background: #042f47;
    }

    .form-shua.disabled {
        background: #6F6F6F;
        color: #FFFFFF;
    }

    .form-shua {
        margin-left: calc(50vw - 55px);
        display: inline-block;
    }

    .form-rt-subhead {
        top: 0;
    }

    .form-rt-body {
        height: calc(100% - 32px);
    }
</style>
